import { useEffect } from 'react';

export default function useScrollAnimation() {
    useEffect(() => {
        const els = document.querySelectorAll('[data-animate]');

        const observer = new IntersectionObserver(
            entries => entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            }),
            { threshold: 0.1 }
        );

        els.forEach(el => observer.observe(el));
        return () => observer.disconnect();
    }, []);
}
